mtl.alloy.factory['show-us-state'] = (function($) {
	'use strict';

	return function(element, options) {

		var $element = $(element);
	
		$($element).on('change', function(){
			showStateSelect($element);
		});

		showStateSelect($element);

	};

	function showStateSelect($element)
	{
		var $stateList = $('[data-type="us-state"]', $($element).closest('form')).closest('.row');
		if($($element).val() == 'US')
		{
			$stateList.show();
		} else {
			$stateList.hide();
		}
	}

}($));
